export interface Image {
  alt: string | null
  src: string | null
}

export enum ImageTypes {
  Master = 'master',
  Standard = 'standard',
  Square = 'square',
}
